import CvSectionTemplate from './CvSectionTemplate';

export default function CvCustom() {
  return (
    <CvSectionTemplate
      currentId="check_7"
      description="Tutaj możesz dodać dowolne treści, które nie mieszczą się w innych sekcjach."
    />
  );
}
